// Lightweight skeleton primitives. Use these instead of spinners while loading.
import React from 'react';

export function Skeleton({ className = '', as: As = 'div', ...rest }) {
  return (
    <As
      className={`animate-pulse bg-[var(--color-border)] rounded-md ${className}`}
      aria-hidden="true"
      {...rest}
    />
  );
}

export function SkeletonText({ lines = 3, className = '' }) {
  return (
    <div className={`space-y-2 ${className}`} aria-hidden="true">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={`skel-line-${i}`} className={`h-3 ${i === lines - 1 ? 'w-2/3' : 'w-full'}`} />
      ))}
    </div>
  );
}

export function SkeletonCard({ className = '' }) {
  return (
    <div className={`p-4 sm:p-5 rounded-2xl border border-[var(--color-border)] bg-white ${className}`}>
      <div className="flex items-start gap-3">
        <Skeleton className="h-10 w-10 rounded-xl" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-3.5 w-2/5" />
          <Skeleton className="h-3 w-3/5" />
        </div>
      </div>
      <SkeletonText lines={2} className="mt-4" />
    </div>
  );
}

export function SkeletonRow({ cols = 4, className = '' }) {
  return (
    <div className={`grid gap-3 py-3 px-4 border-b border-[var(--color-border)] ${className}`} style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
      {Array.from({ length: cols }).map((_, i) => (
        <Skeleton key={i} className="h-3.5" />
      ))}
    </div>
  );
}

export function PageSkeleton({ title = true }) {
  return (
    <div className="px-4 sm:px-6 py-6 max-w-6xl mx-auto space-y-6" data-testid="page-skeleton">
      {title && (
        <div className="space-y-2">
          <Skeleton className="h-7 w-1/3" />
          <Skeleton className="h-3.5 w-1/4" />
        </div>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {Array.from({ length: 4 }).map((_, i) => <SkeletonCard key={i} />)}
      </div>
      <SkeletonCard />
      <SkeletonCard />
    </div>
  );
}

export default Skeleton;
